import Project from 'src/entities/project';
import PermissionsSwitch from '../PermissionsSwitch/PermissionsSwitch';
import useReviewerR0Upload from './useReviewerR0Upload';

const ReviewerR0UploadSwitch = ( { project }: { project: Project } ) => {
	const { reviewerR0UploadEnabled, onReviewerR0UploadChange } = useReviewerR0Upload( { project } );

	return (
		<PermissionsSwitch
			label="Upload New Assets"
			description="Allow reviewers to upload new assets (new rounds not included)"
			checked={reviewerR0UploadEnabled}
			onChange={onReviewerR0UploadChange}
		/>
	);
};

export default ReviewerR0UploadSwitch;
